import React from 'react'
import { Switch } from 'react-router-dom'

import LoadableRoute from '../components/features/share/loadable/loadableRoute'
import { PrivateRoute, PublicRoute, NPIPrivateRoute, AdminPrivateRoute } from './routePermission'

//Layout
const LayoutMaster = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutMaster'),
})
const LayoutBlank = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutBlank'),
})


//Features
//Auth
const Login = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/loginController'),
})
const NotFoundController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/NotFoundController'),
})
const UnAuthenController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/UnAuthenController'),
})

// Home
const HomeController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/homeController'),
})

// Item
const ItemController = LoadableRoute({
    loader: () => import('../components/features/qrtag/controllers/itemController'),
})

// RM Tag
const RmTagController = LoadableRoute({
    loader: () => import('../components/features/qrtag/controllers/rmTagController'),
})

// PD Tag
const PdTagController = LoadableRoute({
    loader: () => import('../components/features/qrtag/controllers/pdTagController'),
})

// Print
const PrintTemplateController = LoadableRoute({
    loader: () => import('../components/features/print/printTemplateController'),
})

export default () => (
    <Switch>

        {/* <PrivateRoute exact path='/masterData/settings' component={HomeController} layout={LayoutMaster} />
        <PrivateRoute exact path='/masterData' component={HomeController} layout={LayoutMaster} />*/}

        <PrivateRoute exact path='/pdtag' component={PdTagController} layout={LayoutMaster} />
        <PrivateRoute exact path='/rmtag' component={RmTagController} layout={LayoutMaster} />
        <PrivateRoute exact path='/print' component={PrintTemplateController} layout={LayoutMaster} />
        <PrivateRoute exact path='/qrtag' component={ItemController} layout={LayoutMaster} />
        <PrivateRoute exact path='/' component={HomeController} layout={LayoutMaster} />

        <PublicRoute path='/login' component={Login} layout={LayoutBlank} />
        <PublicRoute path='/unauthen' component={UnAuthenController} layout={LayoutMaster} />
        <PublicRoute component={NotFoundController} layout={LayoutMaster} />

    </Switch>
)


// WEBPACK FOOTER //
// ./src/app/routes/Routes.js